import axios, { AxiosResponse } from 'axios';

export function debouncedAxiosGet<T>(url: string, timeout = 1000): Promise<AxiosResponse<T>> {
  let timeoutId: NodeJS.Timeout | null = null;
    console.log('debouncedAxiosGet');
  return new Promise((resolve, reject) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      axios.get<T>(url)
        .then(resolve)
        .catch(reject)
        .finally(() => {
          timeoutId = null;
        });
    }, timeout);
  });
}

export const RENAISSANCE_COLORS = {
    "red": "#FD4353",
    "beige": "#F1EFE3",
    "darkgrey": "#54585E",
    "mediumgrey": "#808285",
    "lightgrey": "#DDDEE0",
    "black": "#000000",
    "white": "#FFFFFF",
    "green": "#008000",
    "blue": "#0000FF",
};

export const generateSkillIdUrl = (id: string, version: string | null = null) => {
  if (version) {
    return `/skill/${id}?version=${version}`;
  }
  return `/skill/${id}`;
}

export const GRADE_LEVEL_ORDER = [
  "Preschool",
  "Pre-Kindergarten", 
  "Reception",
  "Kindergarten",
  "Grade 1",
  "Year 1",
  "Grade 2", 
  "Year 2",
  "Grade 3",
  "Year 3", 
  "Grade 4",
  "Year 4",
  "Grade 5",
  "Year 5",
  "Grade 6",
  "Year 6",
  "Grade 7",
  "Year 7",
  "Grade 8",
  "Year 8",
  "Grades 6-8",
  "Grades 7-8",
  "Pre-Algebra",
  "Grade 9",
  "Year 9",
  "Grade 10",
  "Year 10", 
  "Grade 11",
  "Year 11",
  "Grade 12",
  "Grades 9-10",
  "Grades 9-11",
  "Grades 9-12",
  "Grades 11-12",
  "Algebra 1",
  "Algebra 2",
  "Geometry",
  "High School - Algebra",
  "High School - Functions",
  "High School - Geometry",
  "High School - Number and Quantity",
  "High School - Statistics and Probability",
  "High School Integrated Math I",
  "High School Integrated Math II",
  "High School Integrated Math III",
  "English I",
  "English II", 
  "English III",
  "English IV"
]